import ResponsiveTable from '../../../../shared/components/ResponsiveTable';
import { SortedColumn } from '../../../../shared/components/ResponsiveTable/models';
import {
  getBrowserTimezone,
  toPMIFormatDateWithTime,
} from '../../../../shared/helpers';
import { LogModel } from '../../models';
import { LogActionFormatter } from '../../LogActionFormatter';

export interface ErrorLogTableProps {
  logs: LogModel[];
}

const tableColumns = (): SortedColumn[] => [
  {
    name: 'action',
    title: 'Error',
    width: 20,
    sortingEnabled: false,
    cell: ({ row }) => <LogActionFormatter log={row.original} />,
  },
  {
    name: 'agreementID',
    title: 'Agreement ID',
    cell: ({ row }) => {
      if (row.original.data && row.original.data.dealId) {
        return <span>{row.original.data.dealId}</span>;
      }
      return '';
    },

    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'performedBy',
    title: 'Performed By',
    cell: (cntx) => (
      <span data-exclude-lg>{cntx.row.original?.performedBy?.personName}</span>
    ),
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'performedOn',
    title: `Date/Time (${getBrowserTimezone()})`,
    cell: (cntx) => {
      const formattedDate = cntx.row.original?.performedOn
        ? toPMIFormatDateWithTime(cntx.row.original.performedOn)
        : '';
      return (
        <div className={` fw-normal label`} data-testid="data-status">
          {formattedDate}
        </div>
      );
    },
    width: 10,
    sortingEnabled: false,
  },
];

export default function ErrorLogsTable({ logs }: ErrorLogTableProps) {
  return (
    <ResponsiveTable
      data={logs}
      paginationProps={{}}
      columns={tableColumns()}
      showPagination={false}
      onSort={() => {}}
    />
  );
}
